module.exports = __webpack_public_path__ + "img/bouquet_gift.9bfca60f.svg";